import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";

import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";

import { createDeepSelectorRx } from "keautils";
import { filtrarUbicacionesPorColonias, esFiltroColoniaValido, obtenerDescripcionDireccion } from "./logic";
import { shallowEquals } from "keautils";
import { EstadoMunicipioCiudad } from "app/features/selectores/items/municipio/index";
import { Colonias } from "app/features/selectores/simples";
import { observeResource } from "kea-resource";
import { ColoniaComponent } from "./colonia";

const createShallowSelector = createDeepSelectorRx;

type Entity = models.DireccionColonia;
export interface Props {
    value: Entity;
    onChange?: (value: Entity) => PromiseLike<void>;
    listas?: models.Ubicaciones;
    label?: string;
    readonly?: boolean;
    error?: kea.FieldError;
}

interface EstadoMunicipioCiudad {
    estado?: number;
    municipio?: number;
    ciudad?: number;
}


/**
* Valida un NuevoViajeRevisionCobranzaMo
*/
export function validar(x: Entity) {
    const rules: validation.Rules<Entity> = {
        IdColonia: validation.required,
        Calle: validation.required,
        NoExterior: validation.required,
        Telefono: validation.required
    };
    return validation.getErrors(rules, x);
}


/**
* Componente para editar un DireccionColonia
*/
class DireccionComponentNoRx extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    errors = createSelectorRx(this.value, x => validar(x));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));
    getField = formfields(() => this.props, () => this.errors(this.props));


    private onColoniaChange = async (id: number) => {
        const nextVal = { ... this.props.value, IdColonia: id };
        if (this.props.onChange)
            await this.props.onChange(nextVal);
    }

    private onLimpiar = async () => {
        if (this.props.onChange)
            this.props.onChange({ IdColonia: null as any, Calle: null as any, NoExterior: null as any, Telefono: null as any, Email: null as any });
    }

    render() {

        const { value, readonly } = this.props;
        const getField = this.getField;
        const errors = this.errors(this.props);

        const Text = getField(kea.Text);
        const Check = getField(kea.Checkbox);
        return (
            <kea.Panel
                title={this.props.label == null ? "Dirección" : this.props.label}
                iconClass={fa("address-card-o", "fw")}
                error={this.props.error}
                buttons={
                    !this.props.readonly && 
                    <kea.Button iconClass={fa("hand-paper-o")} onClick={this.onLimpiar}  >
                        Limpiar
                    </kea.Button>
                } >
                <ColoniaComponent  {... this.props} value={value && value.IdColonia} onChange={this.onColoniaChange} label={undefined} error={errors.IdColonia} />
                
                {kea.autogrid(4, [
                    <Text field="Calle" />,
                    <Text field="NoExterior" />,
                    <Text field="NoInterior" />,
                    <Text field="Telefono" />,
                    <Text field="Email" />,
                ])}

            </kea.Panel>);
    }
}

export const DireccionComponent = kea.defaultProps(componentToRx(DireccionComponentNoRx), { listas: resources.UbicacionesRx });


// WEBPACK FOOTER //
// ./app/features/componentes/direccion/direccion.tsx